var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55507 0.522782C1.80654 0.464941 2.06922 0.47903 2.31306 0.563438C2.31306 0.563438 2.31306 0.563438 2.31306 0.563438L16.8626 5.59981C17.1366 5.69466 17.3736 5.87371 17.5397 6.11137C17.7059 6.34903 17.7926 6.63313 17.7876 6.92305C17.7825 7.21297 17.686 7.49389 17.5117 7.72563C17.3374 7.95737 17.0943 8.12808 16.8172 8.21336L10.2382 10.2377L8.21385 16.8167C8.12857 17.0938 7.95786 17.3369 7.72612 17.5112C7.49437 17.6855 7.21346 17.7821 6.92354 17.7871C6.63361 17.7921 6.34951 17.7054 6.11186 17.5393C5.8742 17.3731 5.69515 17.1361 5.60029 16.8621L0.563926 2.31257C0.563926 2.31257 0.563926 2.31257 0.563926 2.31257C0.479518 2.06873 0.46543 1.80605 0.523271 1.55458C0.581111 1.30311 0.708547 1.07298 0.89101 0.890521C1.07347 0.708059 1.30359 0.580623 1.55507 0.522782ZM1.21778 2.08624L1.86328 1.86279L6.89965 16.4123L8.92396 9.8333C8.98991 9.61895 9.1073 9.42398 9.26588 9.2654C9.42447 9.10681 9.61943 8.98943 9.83379 8.92347L16.4128 6.89916L1.86328 1.86279L1.86328 1.86279L1.21778 2.08624Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.ba9abadb.svg";
export { ForwardRef as ReactComponent };